import React, { useState, useEffect, useRef } from "react";
import data from "./data/month_year_data.json";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const EducationComponent = ({ user }) => {
  const [trainings, setTrainings] = useState([{}]);
  const [isChecked, setIsChecked] = useState(false);

  const [courses, setCourses] = useState([
    {
      institution: "",
      courseDegree: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      currentCourse: false,
    },
  ]);
  const [errors, setErrors] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const lastCourseRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    const fetchEducationData = async () => {
      if (user && user.id) {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const fetchedUserData = response.data;
          const fetchedCourses = fetchedUserData.educationHistory;
          if (fetchedCourses.length > 0) {
            setCourses(
              fetchedCourses.map((course) => ({
                institution: course.institution || "",
                courseDegree: course.courseDegree || "",
                startMonth: course.startMonth || "",
                startYear: course.startYear || "",
                endMonth: course.currentCourse ? "" : course.endMonth || "",
                endYear: course.currentCourse ? "" : course.endYear || "",
                currentCourse: course.currentCourse || false,
              }))
            );
          } else {
            setCourses([
              {
                institution: "",
                courseDegree: "",
                startMonth: "",
                startYear: "",
                endMonth: "",
                endYear: "",
                currentCourse: false,
              },
            ]);
          }
        } catch (error) {
          console.error("Failed to fetch education data:", error);
        }
      }
    };

    fetchEducationData();
  }, [user, baseURL]);

  useEffect(() => {
    if (courses.length > 1) {
      lastCourseRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  }, [courses.length]);
  
  const addNewCourse = () => {
    setCourses([
      ...courses,
      {
        institution: "",
        courseDegree: "",
        startMonth: "",
        startYear: "",
        endMonth: "",
        endYear: "",
        currentCourse: false,
      },
    ]);
  };

  const deleteCourse = (index) => {
    const updatedCourses = [...courses];
    updatedCourses.splice(index, 1);
    setCourses(updatedCourses);
  };

  const handleDetailChange = (index, field, event) => {
    const updatedCourses = [...courses];
    const newCourse = { ...updatedCourses[index] };
    const value =
      field === "currentCourse" ? event.target.checked : event.target.value;

    newCourse[field] = value;

    if (field === "currentCourse") {
      console.log(`Current course status for course at index ${index}:`, value); // Log the value of `currentCourse`
      if (value) {
        newCourse.endMonth = "";
        newCourse.endYear = "";
      }
    }

    updatedCourses[index] = newCourse;
    setCourses(updatedCourses);
    if (submitAttempted && errors[index] && errors[index][field]) {
      const newErrors = { ...errors };
      delete newErrors[index][field];
      if (Object.keys(newErrors[index]).length === 0) {
        delete newErrors[index];
      }
      setErrors(newErrors);
    }

    if (submitAttempted) {
      validateForm();
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    courses.forEach((course, index) => {
      const courseErrors = {};

      if (!course.institution) {
        courseErrors.institution = "Institution is required *";
      }
      if (!course.courseDegree) {
        courseErrors.courseDegree = "Course or Degree is required *";
      }
      if (!course.startMonth) {
        courseErrors.startMonth = "Start month is required *";
      }
      if (!course.startYear) {
        courseErrors.startYear = "Start year is required *";
      }

      if (!course.currentCourse) {
        if (!course.endMonth) {
          courseErrors.endMonth = "End month is required *";
        }
        if (!course.endYear) {
          courseErrors.endYear = "End year is required *";
        }
      }

      if (Object.keys(courseErrors).length) {
        newErrors[index] = courseErrors;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSave = async () => {
    setSubmitAttempted(true);
    if (validateForm()) {
      console.log("Course Entries:", JSON.stringify(courses, null, 2));
      const educationHistoryData = {
        educationHistory: courses.map((course) => ({
          institution: course.institution,
          courseDegree: course.courseDegree,
          startMonth: course.startMonth,
          startYear: course.startYear,
          endMonth: course.endMonth,
          endYear: course.endYear,
          currentCourse: course.currentCourse,
        })),
      };

      try {
        console.log("Education Details to be Patched: ", educationHistoryData);
        const response = await axios.patch(
          `${baseURL}/v1/worker-users/${user.id}`,
          educationHistoryData
        );
        if (response.data) {
          console.log("Patch successful");
          setShowModal(true);
        }
      } catch (error) {
        console.error("Failed to update education history details", error);
      }
    } else {
      console.error("Validation failed.", errors);
    }
  };

  return (
    <div className="education-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="education-indicative-above-div">
      <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Education and training</h2>
        </div>
        
        <p>
          If you have undergone education and training including degrees,
          courses, diplomas and other qualifications (for example, First Aid,
          Manual Handling), enter them below.
        </p>
      </div>

      {courses.map((course, courseIndex) => (
        <div
          key={courseIndex}
          className="education-details-section"
          ref={courseIndex === courses.length - 1 ? lastCourseRef : null}
        >
          <div className="education-detail-title">
            <h3>Institution</h3>
            <input
              type="text"
              name="institution"
              value={course.institution}
              onChange={(e) =>
                handleDetailChange(courseIndex, "institution", e)
              }
            />
          </div>

          <div className="education-detail-title">
            <h3>Degree/Course</h3>
            <input
              type="text"
              name="courseDegree"
              value={course.courseDegree}
              onChange={(e) =>
                handleDetailChange(courseIndex, "courseDegree", e)
              }
            />
          </div>
          <div className="date-sections-wrapper">
            <div className="education-date-section-start">
              <h3>Start date</h3>
              <div className="horizontal-education-details">
                <div className="education-detail">
                  <h3>Month</h3>
                  <select
                    value={course.startMonth}
                    onChange={(e) =>
                      handleDetailChange(courseIndex, "startMonth", e)
                    }
                  >
                    {data.months.map((month, index) => (
                      <option key={index} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="education-detail">
                  <h3>Year</h3>
                  <select
                    value={course.startYear}
                    onChange={(e) =>
                      handleDetailChange(courseIndex, "startYear", e)
                    }
                  >
                    {data.years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="education-date-section-end">
              <h3>End date</h3>
              <div className="horizontal-education-details">
                <div className="education-detail">
                  <h3>Month</h3>
                  <select
                    value={course.endMonth}
                    onChange={(e) =>
                      handleDetailChange(courseIndex, "endMonth", e)
                    }
                    disabled={course.currentCourse}
                  >
                    {data.months.map((month, index) => (
                      <option key={index} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="education-detail">
                  <h3>Year</h3>
                  <select
                    value={course.endYear}
                    onChange={(e) =>
                      handleDetailChange(courseIndex, "endYear", e)
                    }
                    disabled={course.currentCourse}
                  >
                    {data.years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="education-checkbox-section">
                <input
                  type="checkbox"
                  checked={course.currentCourse}
                  onChange={(e) =>
                    handleDetailChange(courseIndex, "currentCourse", e)
                  }
                />
                <label>Currently enrolled in this course.</label>
              </div>
            </div>
          </div>
          {errors[courseIndex] && (
            <div className="education-error">
              <ul>
                {Object.values(errors[courseIndex]).map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          )}
          <div className="education-add-remove-button-container">
            <button className="education-history-add" onClick={addNewCourse}>
              + Add course
            </button>
            {courses.length > 1 && (
              <button
                className="education-history-delete"
                onClick={() => deleteCourse(courseIndex)}
              >
                Remove
              </button>
            )}
          </div>
        </div>
      ))}

      <div className="education-save">
        <button onClick={handleSave}>Save and continue</button>
      </div>
    </div>
  );
};

export default EducationComponent;
